module.exports = __webpack_public_path__ + "static/media/42.35c0fd7.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/42.wav
// module id = 9YTN
// module chunks = 0